module.exports = __webpack_public_path__ + "static/5-ab6809a98488298e527558266c41c763.jpg";